var React = require('react');

function MTVHome (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"153.77","y":"126.015","fill":"#D6B2D0","width":"8.626","height":"31.903","key":0}),React.createElement("polygon",{"fill":"#4BACEC","points":"71.492,42.082 17.271,86.445 17.271,157.918 125.713,157.918 125.713,86.445 \t","key":1}),React.createElement("circle",{"fill":"#8CC63F","cx":"158.391","cy":"107.086","r":"24.338","key":2})]));
}

MTVHome.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 200","enableBackground":"new 0 0 200 200","xmlSpace":"preserve"};

module.exports = MTVHome;

MTVHome.default = MTVHome;
